const STORAGE_KEYS = {
  conversationId: "assistantConversationId",
  messages: "assistantMessages",
  panelOpen: "assistantPanelState",
};

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function readJSON(key, fallback) {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

export function generateConversationId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, "0"));
  return [
    hex.slice(0, 4).join(""),
    hex.slice(4, 6).join(""),
    hex.slice(6, 8).join(""),
    hex.slice(8, 10).join(""),
    hex.slice(10, 16).join(""),
  ].join("-");
}

function normalizeConversationId(value) {
  return UUID_PATTERN.test(value || "") ? value : generateConversationId();
}

export function loadAssistantState() {
  if (typeof window === "undefined") {
    return {
      conversationId: generateConversationId(),
      messages: [],
      panelOpen: false,
    };
  }

  const persistedConversationId = sessionStorage.getItem(STORAGE_KEYS.conversationId);

  return {
    conversationId: normalizeConversationId(persistedConversationId),
    messages: readJSON(STORAGE_KEYS.messages, []),
    panelOpen: readJSON(STORAGE_KEYS.panelOpen, false),
  };
}

export function saveAssistantState({ conversationId, messages, panelOpen }) {
  if (typeof window === "undefined") return;

  sessionStorage.setItem(STORAGE_KEYS.conversationId, conversationId);
  sessionStorage.setItem(STORAGE_KEYS.messages, JSON.stringify(messages));
  sessionStorage.setItem(STORAGE_KEYS.panelOpen, JSON.stringify(panelOpen));
}
